import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import { getSeoVisibility } from '../../../src/appconfig';
import { HomeWrapper } from '../../../src/components/HomePage/HomeBanner/styled';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
import { categoryUrlData } from '../../../src/Constants/CommunityCategory';
import { relatedArticlesContent } from '../../../src/Constants/HomePage';
import {
  getFeedsData,
  getTagDetailPageByTagId,
  getTopicDetailData,
  utilitesFetcher,
} from '../../../src/datafetchers/HomePage';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import {
  getCategoryKey,
  getDestinationUrl,
  getEncodedUrl,
  getFilteredCategoryContent,
} from '../../../src/Utils/helper';

import NewTopicDesign from '../../../src/components/CategoryDetail/TopicDetail/NewTopicDesign';
import OldTopicDetail from '../../../src/components/CategoryDetail/TopicDetail/OldTopicDetail';
import { tabByKeyFetcher } from '../../../src/datafetchers/CategoryPage';
// const NewFooter = dynamic(() =>
//     import("../../../src/components/HomePage/NewFooter"),
// );
import { getPostUrl } from '../../../src/datafetchers/CommunitySitemap';
import { storeDataFetcher } from '../../../src/datafetchers/Store';
import { fireViewedScreenEvent } from '../../../src/Utils/useFirebase';

export async function getStaticPaths() {
  return {
    paths: [
      {
        params: {
          topicPage: 'diet-nutrition-4145',
        },
      },
    ],
    fallback: 'blocking',
  };
}

export async function getStaticProps(context) {
  const webUrl = context.params.topicPage;
  const id = webUrl?.split('-')?.pop();
  if (isNaN(id) || isNaN(webUrl)) {
    const filteredObject = categoryUrlData.filter(
      (item) => item.name == context.params.topicPage,
    );
    const tagId =
      filteredObject?.[0]?.id || getCategoryKey(context.params.topicPage);
    try {
      const getTagDetail = await getTagDetailPageByTagId({
        tagId: tagId,
      });
      const generalTabsName = getTagDetail?.data?.generalTabs;
      const tagData = getTagDetail?.data?.tagData;
      const checkToShowNewDesign = tagData?.is_general_tab_eligible;
      const params = {
        key: 'topic_all',
        tagId: tagId,
        isForGeneralTabFromWeb: true,
      };
      const generalTabsDataInDetail = checkToShowNewDesign
        ? await tabByKeyFetcher(params)
        : null;
      const feedData = await getFeedsData({
        tag: tagId,
        page: 1,
        type: 'featured',
        shortenFeedResponse: true,
      });
      const generalTabsProductsData = generalTabsDataInDetail?.data || null;
      const toolsData = await utilitesFetcher();
      const data = await storeDataFetcher({
        skip: 0,
        limit: 10,
        lang: 'en',
        inApp: false,
        desktopView: true,
        key: 'store',
      });
      return {
        props: {
          feedData,
          tagData,
          tagId,
          generalTabsName,
          checkToShowNewDesign,
          generalTabsProductsData,
          toolsData,
          categoryData: getFilteredCategoryContent(data?.data?.categories),
        },
      };
    } catch (error) {
      if (error?.response?.status == '400') {
        return {
          notFound: true,
          revalidate: 60,
        };
      } else {
        return {
          redirect: {
            destination: '/500',
          },
        };
      }
    }
  } else {
    // 301/404 redirect when only Id/wrong Id is in the URL
    try {
      const topicUrls = await getPostUrl();
      const urlRecognised = getDestinationUrl(topicUrls?.data, id);

      if (urlRecognised) {
        const final_url = getEncodedUrl(urlRecognised);
        return {
          redirect: {
            destination: final_url,
            statusCode: 301,
          },
        };
      }
      return {
        notFound: true,
      };
    } catch (error) {
      if (error?.response?.status == '404') {
        return {
          notFound: true,
          revalidate: 60,
        };
      } else {
        return {
          redirect: {
            destination: '/500',
          },
        };
      }
    }
  }
}

export default function TopiCPageComponent(props) {
  const {
    feedData,
    tagData,
    tagId,
    generalTabsName,
    checkToShowNewDesign,
    toolsData,
    generalTabsProductsData,
    categoryData,
  } = props;

  const { topicDetailData } = getTopicDetailData(tagId, {
    feedData,
    tagData,
    generalTabsName,
    generalTabsProductsData,
    checkToShowNewDesign,
  });
  const itemsArray = topicDetailData?.feedData?.data?.posts;
  const updatedTagData = topicDetailData?.tagData;
  const updatedGeneralTabsName = topicDetailData?.generalTabsName;
  const updatedGeneralTabsProductsData =
    topicDetailData?.generalTabsProductsData;
  const [addedToCart, setAddedToCart] = useState(false);

  const metaTitle = tagData?.[0]?.description
    ? `${tagData?.[0]?.description} | Mylo Community Topic`
    : 'Explore Topics | Mylo';
  const metaDescription = tagData?.[0]?.meta_description
    ? `${tagData?.[0]?.meta_description}, explore pregnancy and baby conception information at Mylo`
    : 'Explore pregnancy and baby conception information at Mylo';
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'website',
    url: `https://mylofamily.com${tagData?.[0]?.web_url || '/'}`,
    images: [
      {
        url: 'https://mylofamily.com/v2/static/images/512mylo.png',
        width: 512,
        height: 512,
      },
    ],
  };
  const showNewdesign = () => {
    return checkToShowNewDesign;
  };

  useEffect(() => {
    fireViewedScreenEvent(tagId, updatedTagData?.description);
  }, []);

  const oldTopicDesignProps = {
    tagId,
    relatedArticlesContent,
  };
  const newTopicDesignProps = {
    tagId,
    toolsData,
    setAddedToCart,
    addedToCart,
  };

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <Head>
            {tagData?.[0]?.web_url ? (
              <link
                key="canonical"
                rel="canonical"
                href={`https://mylofamily.com${tagData?.[0]?.web_url}`}
              />
            ) : null}
            {updatedTagData?.image && (
              <link rel="preload" as="image" href={updatedTagData?.image} />
            )}
          </Head>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
          />
        </>
      ) : null}
      <GlobalStyle />
      <NewHeader
        setAddedToCart={setAddedToCart}
        addedToCart={addedToCart}
        categoryData={categoryData}
        nostrip={true}
      />
      <HomeWrapper>
        {showNewdesign() ? (
          <NewTopicDesign
            {...newTopicDesignProps}
            tagData={updatedTagData}
            generalTabsName={updatedGeneralTabsName}
            updatedGeneralTabData={itemsArray}
            generalTabsProductsData={updatedGeneralTabsProductsData}
          />
        ) : (
          <OldTopicDetail
            {...oldTopicDesignProps}
            tagData={updatedTagData}
            itemsArray={itemsArray?.items}
          />
        )}
      </HomeWrapper>
      <NewFooter />
    </>
  );
}
